import { IApplicationState } from '../../types/redux';

export const selectRealtyListItems = (state: IApplicationState) => state.myHome?.realtyList.data;
